import React from 'react';
import { Body, Heading } from 'components/text';
import Container from 'components/container';
import styles from './Article.module.scss';
import type { TravelJournalArticleProps } from './types';
import { getHotelPageLink } from './utils';
import ContentBlocks from './content-blocks';
import ArticleMetaData from './article-meta-data';
import HeaderHero from './header-hero';
import { parseText } from './parseText';
import Breadcrumbs from 'components/breadcrumbs';

const Article: React.FC<TravelJournalArticleProps> = ({ article }) => {
  const {
    title,
    subheading,
    header_image,
    intro_paragraph,
    content_blocks,
    categories,
  } = article;
  const primaryCategory = article.categories[0];
  const { hotel_id, link } = header_image;
  const hotelPageLink = getHotelPageLink(hotel_id, link);

  return (
    <main>
      <HeaderHero hotelPageLink={hotelPageLink} headerImage={header_image} />
      <Container as="article" className={styles.contentContainer}>
          <section className={styles.backButton}>
            <Breadcrumbs
              setRouteList={() => [
                {
                  name: 'Travel Journal',
                  href: '/travel-journal',
                },
                {
                  name: primaryCategory.name,
                  href: `/travel-journal/${primaryCategory.slug}`,
                },
                {
                  name: title,
                  href: ''
                },
              ]}
            />
          </section>
          <Container className={styles.content}>
            <div className={styles.categories}>
              {categories.map((category, index) => (
                <Body
                  key={index}
                  color="gold-dark"
                  weight="demiBold"
                  fontSize={18}
                >
                  {category.name}
                </Body>
              ))}
            </div>
            <Heading as="h1" color="black">
              {title}
            </Heading>
            <div className={styles.subContent}>
              <div className={styles.subheading}>
                <Heading as="h5" color="grey-dark">
                  {subheading}
                </Heading>
              </div>
              <ArticleMetaData article={article} />
              <div className={styles.introParagraph}>
                {parseText(intro_paragraph)}
              </div>
            </div>
            <ContentBlocks blocks={content_blocks} />
          </Container>
        </Container>
    </main>
  );
};

export default Article;
